import { render, staticRenderFns } from "./DetailMessage.vue?vue&type=template&id=78c7008f&scoped=true"
import script from "./DetailMessage.vue?vue&type=script&lang=js"
export * from "./DetailMessage.vue?vue&type=script&lang=js"
import style0 from "./DetailMessage.vue?vue&type=style&index=0&id=78c7008f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c7008f",
  null
  
)

export default component.exports